<template>
    <div class="row justify-content-center">
        <div class="col-lg-3 col-md-6 col-sm-8 col-12 mt-5 mb-5">
            <template v-if="step==='verify'">
                <verify-otp @cancel="reset()" :mobile="mobile" />
            </template>
            <template v-else>
                <request-otp @request="step = 'verify'" v-model="mobile" />
            </template>
        </div>
    </div>
</template>

<script>
import VerifyOtp from "./VerifyOtp";
import RequestOtp from "./RequestOtp";
export default {
    components: {RequestOtp, VerifyOtp},
    name: "Login",
    data() {
        return {
            step: 'request',
            mobile: '',
        }
    },
    methods: {
        reset(){
            this.step = 'request';
            this.mobile = '';
            localStorage.setItem('_otp_mobile', '');
        }
    },
    mounted() {
        const mobile = localStorage.getItem('_otp_mobile');
        if (mobile) {
           this.step = 'verify';
           this.mobile = mobile;
        }
    }
}
</script>

<style scoped>

</style>
